<template>
  <header class="nourish-header" v-if="showHeader && !hasMini && !isSwiper" id="header">
    <div class="inner-header">
      <div class="left">
        <component :is="brandTag" class="heading-brand" @click="possibleTop($event);" data-to="/">
          {{ seo.title || 'Nourish - Smart, healthy news.' }}
        </component>

        <nav class="links">
          <RouterLink to="/" class="tab-item" :class="{'active' : routeMetaTab === 'home'}" @click.native="refreshHome()">
            <!-- <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.86042 1.874H4.78088C5.13296 1.874 5.42103 2.1551 5.42103 2.49866V3.74799H2.22026V2.49866C2.22026 2.1551 2.50833 1.874 2.86042 1.874ZM2.22026 5.62199H5.42103V14.3673H2.22026V5.62199ZM7.34149 2.57675V2.49866C7.34149 1.12049 6.19322 0 4.78088 0H2.86042C1.44808 0 0.299805 1.12049 0.299805 2.49866V17.4906C0.299805 18.8688 1.44808 19.9893 2.86042 19.9893H4.78088C5.38502 19.9893 5.94116 19.7824 6.38126 19.4427C6.82137 19.7863 7.3775 19.9893 7.98164 19.9893H9.90211C11.3144 19.9893 12.4627 18.8688 12.4627 17.4906V11.0722L14.4072 18.1465C14.7713 19.4779 16.1756 20.2704 17.5439 19.9151L19.4004 19.431C20.7647 19.0757 21.5769 17.7054 21.2128 16.3701L17.2279 1.88571C16.8638 0.554391 15.4594 -0.238154 14.0911 0.121029L12.2387 0.605145C11.2624 0.858915 10.5663 1.63584 10.3862 2.54551C10.2302 2.51428 10.0661 2.50257 9.90211 2.50257H7.98164C7.76159 2.50257 7.54554 2.5299 7.34149 2.58065V2.57675ZM7.34149 4.99732C7.34149 4.65376 7.62956 4.37266 7.98164 4.37266H9.90211C10.2542 4.37266 10.5423 4.65376 10.5423 4.99732V17.4906C10.5423 17.8342 10.2542 18.1153 9.90211 18.1153H7.98164C7.62956 18.1153 7.34149 17.8342 7.34149 17.4906V4.99732ZM5.42103 17.4906C5.42103 17.8342 5.13296 18.1153 4.78088 18.1153H2.86042C2.50833 18.1153 2.22026 17.8342 2.22026 17.4906V16.2413H5.42103V17.4906ZM14.5912 1.92865C14.9313 1.83886 15.2834 2.03797 15.3754 2.36982L15.7075 3.57621L12.6148 4.38437L12.2827 3.17799C12.1907 2.84613 12.3947 2.50257 12.7348 2.41277L14.5912 1.92865ZM15.4314 14.6445L13.1109 6.1959L16.2036 5.38774L18.5242 13.8363L15.4314 14.6445ZM15.9275 16.456L19.0203 15.6479L19.3524 16.8543C19.4444 17.1861 19.2403 17.5297 18.9003 17.6195L17.0438 18.1036C16.7037 18.1934 16.3517 17.9943 16.2596 17.6624L15.9275 16.456Z" fill="black"/>
            </svg> -->
            <span>Nourish</span>
          </RouterLink>

          <RouterLink to="/topics" class="tab-item" :class="{'active' : routeMetaTab === 'explore'}" @click.native="tap('Headlines')">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.5996 10.5C18.5996 6.02649 14.9735 2.40039 10.5 2.40039C6.02646 2.40039 2.40036 6.02649 2.40036 10.5C2.40036 14.9735 6.02646 18.5996 10.5 18.5996C14.9735 18.5996 18.5996 14.9735 18.5996 10.5ZM13.9697 6.20801C14.2032 6.13033 14.4607 6.19123 14.6347 6.36523C14.8087 6.53924 14.8696 6.7968 14.792 7.03027L12.9541 12.543C12.8975 12.7127 12.7741 12.8506 12.6142 12.9258L12.5429 12.9541L7.03024 14.792C6.79677 14.8697 6.53921 14.8088 6.3652 14.6348C6.1912 14.4608 6.1303 14.2032 6.20798 13.9697L8.04587 8.45703L8.07419 8.38574C8.14938 8.22588 8.28732 8.10246 8.457 8.0459L13.9697 6.20801ZM9.17575 9.17578L7.85251 13.1465L11.8232 11.8232L13.1465 7.85254L9.17575 9.17578ZM19.9004 10.5C19.9004 15.6915 15.6914 19.9004 10.5 19.9004C5.30849 19.9004 1.09958 15.6915 1.09958 10.5C1.09958 5.30852 5.30849 1.09961 10.5 1.09961C15.6914 1.09961 19.9004 5.30852 19.9004 10.5Z" />
            </svg>
            <span>Topics</span>
          </RouterLink>

          <RouterLink to="/search" class="tab-item" :class="{'active' : routeMetaTab === 'search'}" @click.native="tap('Search')" v-if="isSignedIn">
            <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 9.09961C16 5.50976 13.0899 2.59961 9.5 2.59961C5.91015 2.59961 3 5.50976 3 9.09961C3 12.6895 5.91015 15.5996 9.5 15.5996C13.0899 15.5996 16 12.6895 16 9.09961ZM17 9.09961C17 10.9907 16.2985 12.7169 15.1436 14.0361L19.9219 18.8145L19.9863 18.8926C20.1145 19.0867 20.0927 19.3506 19.9219 19.5215C19.751 19.6923 19.487 19.7141 19.293 19.5859L19.2148 19.5215L14.4365 14.7432C13.1173 15.8981 11.3911 16.5996 9.5 16.5996C5.35786 16.5996 2 13.2417 2 9.09961C2 4.95747 5.35786 1.59961 9.5 1.59961C13.6421 1.59961 17 4.95747 17 9.09961Z" />
            </svg>
            <span>Ask</span>
          </RouterLink>

          <RouterLink to="/dashboard" class="tab-item" :class="{'active' : routeMetaTab === 'dashboard'}" @click.native="tap('Search')" v-if="isSignedIn">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.0312 10.5C19.0312 5.7873 15.2127 1.96875 10.5 1.96875C5.7873 1.96875 1.96875 5.7873 1.96875 10.5C1.96875 15.2127 5.7873 19.0312 10.5 19.0312C15.2127 19.0312 19.0312 15.2127 19.0312 10.5ZM0 10.5C0 4.70039 4.70039 0 10.5 0C16.2996 0 21 4.70039 21 10.5C21 16.2996 16.2996 21 10.5 21C4.70039 21 0 16.2996 0 10.5Z" fill="black"/>
            </svg>
            <span>Dashboard</span>
          </RouterLink>

          <div @click="routeProfile()" class="tab-item" :class="{'active' : routeMetaTab === 'profile'}" v-if="isSignedIn">
            <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.78571 5.25C5.78571 3.43711 7.22411 1.96875 9 1.96875C10.7759 1.96875 12.2143 3.43711 12.2143 5.25C12.2143 7.06289 10.7759 8.53125 9 8.53125C7.22411 8.53125 5.78571 7.06289 5.78571 5.25ZM14.1429 5.25C14.1429 2.3502 11.8406 0 9 0C6.15938 0 3.85714 2.3502 3.85714 5.25C3.85714 8.1498 6.15938 10.5 9 10.5C11.8406 10.5 14.1429 8.1498 14.1429 5.25ZM1.92857 19.6875C1.92857 16.7877 4.2308 14.4375 7.07143 14.4375H10.9286C13.7692 14.4375 16.0714 16.7877 16.0714 19.6875V20.0156C16.0714 20.5611 16.5013 21 17.0357 21C17.5701 21 18 20.5611 18 20.0156V19.6875C18 15.7008 14.8339 12.4688 10.9286 12.4688H7.07143C3.16607 12.4688 0 15.7008 0 19.6875V20.0156C0 20.5611 0.429911 21 0.964286 21C1.49866 21 1.92857 20.5611 1.92857 20.0156V19.6875Z" fill="black"/>
            </svg>
            <span>Profile</span>
          </div>
        </nav>
      </div>

      <div class="right">
        <div class="right-content">
          <div class="profile-stack" v-if="isSignedIn && isNourish2" @click.stop="toggleProfile()">
            <div to="/account" class="user-account" :class="{'active' : $route.path == '/account'}">
              <div class="stats">
                <div class="stat">
                  <XP/>
                </div>
              </div>
            </div>

            <transition name="expand">
              <div v-show="showProfile" class="profile-expand">
                <div class="stack">
                  <div class="xp">
                    <div class="stack-group">
                      <div class="stack-stat">
                        <div class="icon">
                          <svg width="559" height="566" viewBox="0 0 559 566" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M206.5 85.3C203.9 79.6 198.2 76 192 76C185.8 76 180.1 79.6 177.5 85.3L124.4 200.3L9.4 253.4C3.6 256.1 0 261.8 0 268C0 274.2 3.6 279.9 9.3 282.5L124.3 335.6L177.4 450.6C180 456.3 185.7 459.9 191.9 459.9C198.1 459.9 203.8 456.3 206.4 450.6L259.5 335.6L374.5 282.5C380.2 279.9 383.8 274.2 383.8 268C383.8 261.8 380.2 256.1 374.5 253.5L259.5 200.4L206.4 85.4L206.5 85.3Z" fill="black"/>
                            <path d="M347.5 459.2L404 438L425.2 381.5C426.9 377 431.2 374 436 374C440.8 374 445.1 377 446.8 381.5L468 438L524.5 459.2C529 460.9 532 465.2 532 470C532 474.8 529 479.1 524.5 480.8L468 502L446.8 558.5C445.1 563 440.8 566 436 566C431.2 566 426.9 563 425.2 558.5L404 502L347.5 480.8C343 479.1 340 474.8 340 470C340 465.2 343 460.9 347.5 459.2Z" fill="black"/>
                            <path d="M367 96C367 91.2 370 86.9 374.5 85.2L431 64L452.2 7.5C453.9 3 458.2 0 463 0C467.8 0 472.1 3 473.8 7.5L495 64L551.5 85.2C556 86.9 559 91.2 559 96C559 100.8 556 105.1 551.5 106.8L495 128L473.8 184.5C472.1 189 467.8 192 463 192C458.2 192 453.9 189 452.2 184.5L431 128L374.5 106.8C370 105.1 367 100.8 367 96Z" fill="black"/>
                          </svg>
                        </div>
                        <span class="count">{{ getXPToday | stat }}</span>
                        <span class="label">XP<br>Today</span>
                      </div>
                      <div class="average">
                        <span class="count">{{ getXPAvg | stat }} XP</span>
                        <span class="label">Average</span>
                      </div>
                    </div>

                    <div class="xp-progress">
                      <div class="avg-marker">
                        <span>Avg.</span>
                        <div class="marker-mark"></div>
                      </div>
                      <div class="inner-progress" :style="`width: ${getXPProgress}%;`"></div>
                    </div>
                  </div>

                  <div class="streak" :class="{'streak-today' : hasStreakToday}">
                    <div class="stack-group">
                      <div class="stack-stat">
                        <div class="icon">
                          <svg width="448" height="544" viewBox="0 0 448 544" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M160.5 5.60002C169.8 -2.19998 183.6 -1.79998 192.4 6.50002C204.6 18.1 215.7 30.9 226.3 43.9C239.8 60.4 256 82.2 271.6 108.1C276.8 101.3 281.6 95.3 285.8 90.2C286.9 88.9 288 87.5 289.2 86.1C297 76.3 306.9 64 320 64C333.4 64 342.8 75.9 350.8 86.1C352.1 87.8 353.4 89.4 354.7 90.9C365 103.3 378.7 121.2 392.4 143.3C419.6 187.2 448 249.7 448 319.9C448 443.6 347.7 543.9 224 543.9C100.3 543.9 0 443.7 0 320C0 228.9 41.1 150 80.5 95C100.4 67.3 120.2 45.1 135.1 29.9C143.3 21.5 151.6 13.2 160.6 5.70003L160.5 5.60002ZM289.8 166.3C285.2 173.6 277 177.9 268.4 177.5C259.8 177.1 252 172.1 248.1 164.3C229.1 126.7 206.8 95.8 189.2 74.2C184 67.8 179.2 62.2 175 57.6C173.2 59.3 171.4 61.2 169.4 63.2C155.8 77.2 137.6 97.5 119.5 122.8C82.9 173.8 48 242.9 48 319.8C48 417 126.8 495.8 224 495.8C321.2 495.8 400 417 400 319.8C400 262.1 376.4 208.5 351.6 168.4C340.3 150.1 328.9 135 320 124C311.5 134.5 300.7 148.8 289.8 166.1V166.3ZM225.7 448C162.5 448 112 407.4 112 338.8C112 291.3 145.2 252.3 163.5 234.5C169.8 228.4 179.6 229.5 185 236.4C201.2 256.9 233 297.3 250.3 319.4C256.5 327.3 268.4 327.6 275 319.9L300.2 290.6C306.7 283 318.2 283.7 322.7 292.6C348 338.8 336.7 397.6 294.6 427C273.5 441 251.1 448 225.8 448H225.7Z" fill="black"/>
                          </svg>
                        </div>
                        <span class="count">{{ getStreak | stat }}</span>
                        <span class="label">Day<br>Streak</span>
                      </div>
                      <div class="average">
                        <span class="count" v-if="hasStreakToday">Great work!</span>
                        <span class="count" v-else>Read any channel to<br>keep your streak.</span>
                      </div>
                    </div>
                  </div>

                  <div class="stack-actions">
                    <button @click.stop="routeProfile()" class="stack-btn">My profile</button>
                    <button @click.stop="routeAccount()" class="stack-btn">Manage account</button>
                  </div>
                </div>
              </div>
            </transition>
          </div>

          <div class="button-stack">
            <button v-if="!isSignedIn" class="button sign-in" @click="startOnboarding()">
              <span>Get started</span>
              <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.88355 11.6569C8.68829 11.8521 8.37171 11.8521 8.17645 11.6569C7.98118 11.4616 7.98118 11.145 8.17645 10.9498L12.6262 6.49999L0.5 6.49999C0.223857 6.49999 4.70472e-07 6.27613 4.46331e-07 5.99999C4.2219e-07 5.72385 0.223857 5.49999 0.5 5.49999L12.6262 5.49999L8.17645 1.05021C7.98118 0.854947 7.98118 0.538364 8.17645 0.343102C8.37171 0.14784 8.68829 0.14784 8.88355 0.343102L14.1869 5.64644C14.3821 5.8417 14.3821 6.15828 14.1869 6.35354L8.88355 11.6569Z" fill="white"/>
              </svg>
            </button>

            <button v-if="isSignedIn && !isNourish2" @click="upgrade('onesub')" class="button sign-in">
              <span>Upgrade to Nourish 2</span>
              <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.88355 11.6569C8.68829 11.8521 8.37171 11.8521 8.17645 11.6569C7.98118 11.4616 7.98118 11.145 8.17645 10.9498L12.6262 6.49999L0.5 6.49999C0.223857 6.49999 4.70472e-07 6.27613 4.46331e-07 5.99999C4.2219e-07 5.72385 0.223857 5.49999 0.5 5.49999L12.6262 5.49999L8.17645 1.05021C7.98118 0.854947 7.98118 0.538364 8.17645 0.343102C8.37171 0.14784 8.68829 0.14784 8.88355 0.343102L14.1869 5.64644C14.3821 5.8417 14.3821 6.15828 14.1869 6.35354L8.88355 11.6569Z" fill="white"/>
              </svg>
            </button>

            <button v-if="isSignedIn && isNourish2 && !isPro" class="pro" @click="triggerGoPro()">
              <svg width="544" height="432" viewBox="0 0 544 432" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M302.3 66.1C308.4 59.1 312 50 312 40C312 17.9 294.1 0 272 0C249.9 0 232 17.9 232 40C232 50 235.7 59.1 241.7 66.1L168.1 176.6L79 129.1C79.7 126.2 80 123.2 80 120C80 97.9 62.1 80 40 80C17.9 80 0 97.9 0 120C0 140.2 15 156.9 34.4 159.6L70.8 359.7C78.4 401.5 114.9 432 157.4 432H386.6C429.1 432 465.6 401.6 473.2 359.7L509.6 159.6C529.1 156.9 544 140.2 544 120C544 97.9 526.1 80 504 80C481.9 80 464 97.9 464 120C464 123.1 464.4 126.1 465 129.1L375.9 176.6L302.3 66.2V66.1ZM196 221.3L272 107.3L348 221.3C354.8 231.6 368.4 235 379.3 229.2L455.5 188.6L425.9 351.2C422.4 370.2 405.9 384 386.5 384H157.3C138 384 121.4 370.2 117.9 351.2L88.3 188.6L164.5 229.2C175.4 235 188.9 231.6 195.8 221.3H196Z" fill="black"/>
              </svg>
              <span>Pro</span>
            </button>

            <button v-if="showGetApp" class="app" @click="getApp()">
              <span>Get App</span>
            </button>
          </div>
        </div>

        <RouterLink v-if="isSignedIn" to="/dashboard" class="user-track">
          <UserTrack :size="70" />
        </RouterLink>
      </div>
    </div>
    <div class="drop-header" v-if="isDesktop">
      <ul class="section-nav">
        <li><router-link :to="`/`" :title="`Top stories`" :class="{ 'active': isSectionActive('home') }">Today</router-link></li>
        <li v-for="section in getSections" :key="`section-nav:${section.code}`"><router-link :to="`/${section.code}`" :title="`Top ${section.name} stories`" :class="{ 'active': isSectionActive(section.code) }">{{ section.name }}</router-link></li>
      </ul>
    </div>
  </header>
</template>

<script>
  import API from 'app/axios';
  import UserTrack from '@/components/v5/elements/UserTrack.vue';
  import XP from '@/components/_v5/base/header/XP.vue'

  export default {
    data() {
      return {
        showProfile: false
      }
    },

    components: {
      UserTrack,
      XP,
    },

    computed: {
      isAlpha() {
        return this.$store.getters.isAlpha;
      },

      isDesktop() {
        return this.$layoutEngine.isDesktop;
      },

      getAccount() {
        return this.$store.getters.getAccount;
      },

      hasMini() {
        return this.$store.getters.hasMini;
      },

      isInviteFlow() {
        return this.$userEngine.isInviteFlow;
      },

      showHeader() {
        if (this.isLander) {
          if (this.isSignedIn && this.isNourish2) {
            return true;
          }

          return this.isDesktop; // false;
        }

        return true;
      },

      isLander() {
        return this.$route.path == '/';
      },

      isSwiper() {
        return false;
        // return this.$route.meta.swiper && !this.$route.meta.nav && !this.isDesktop;
      },

      isSignedIn() {
        return this.$store.getters.isLoggedIn; 
      },

      isPro() {
        return this.$store.getters.isPro;
      },

      isNourish2() {
        return this.$store.getters.isNourish2;
      },

      showGetApp() {
        return !this.$store.getters.hasApp;
      },

      seo() {
        return this.$store.getters.getSEO;
      },

      brandTag() {
        if (this.$route.path === '/') {
          return 'h1'
        }
        return 'a'
      },

      routeMetaTab() {
        return this.$route.meta?.tab || 'home';
      },

      getXPToday() {
        return this.$store.getters.getXPToday;
      },

      getXPAvg() {
        return this.$store.getters.getXPAvg;
      },

      getXPProgress() {
        const xpLength = this.getXPAvg + ((this.getXPAvg || 100) * 0.15);
        const currentXp = this.getXPToday;
        if (!xpLength) return 0;
        const progress = (currentXp / xpLength) * 100;
        return Math.min(100, Math.max(0, Math.round(progress)));
      },

      getStreak() {
        return this.$userEngine.getStreak;
      },

      hasStreakToday() {
        return this.$userEngine.hasStreakToday;
      },

      getStreakBest() {
        return 0;
      },


      getSections() {
        return [
          {
            code: 'politics',
            name: 'Politics'
          },        
          {
            code: 'business',
            name: 'Business & Economics'
          },       
          {
            code: 'science-and-tech',
            name: 'Science & Tech'
          },         
          {
            code: 'environment',
            name: 'Environment'
          },            
          {
          code: 'society',
          name: 'Society'
          },
          {
            code: 'culture',
            name: 'Culture & Entertainment'
          },
          {
            code: 'sport',
            name: 'Sport'
          },              
        ];
      },

      isNourish1() {
        return this.$userEngine.isNourishLegacy;
      },

    },

    methods: {
      // drop-header active state -- not router-link-active (prefix-matches '/') or exact-active (breaks on ?edition=)
      isSectionActive(code) {
        if (code == 'home') return this.$route.path == '/';
        if (this.$route.params?.section == code) return true;
        if (this.$route.params?.mode == 'story') {
          // full story?
          let oStory = this.$store.getters.getStoryV3(this.$route.params?.slug);
          if (oStory) {
            return code == oStory?.meta?.category?.slug;
          }
        }
        return false;
      },

      upgrade(sFallbackInvite = null) {
        if (!this.$userEngine.getOnboardMemo()?.invited_by) {
          this.$userEngine.setOnboardMemo({
            invited_by: 'onesub',
          });
        }
        let sInvite = this.$userEngine.getOnboardMemo()?.invited_by || sFallbackInvite;
        if (sInvite) {
          this.EventBus.$emit('layer:new', {
            'component': 'Invite',
            'opts': {},
          });
        } else {
          this.EventBus.$emit('modal:nourish-appflow');
        }
      },

      toggleProfile() {
        this.showProfile = !this.showProfile
      },

      refreshHome() {
        this.tap('Home', 'medium');
        API.getStackShelves();
        window.scrollTo({top: 0, behavior: 'smooth'});
      },

      tap(sTab, sNote = 'light') {
        this.EventBus.$emit("device:haptic", sNote);
        this.EventBus.$emit('track:event', {
          event: 'tap-nav',
          props: {
            tab: sTab,
          },
          detail: {
            detail_char: sTab,
          },
        });
      },

      routeProfile() {
        this.showProfile = false;
        this.tap('Profile');
        if (this.isSignedIn) {
          if (this.isNourish2) {
            this.tap('Profile');
            this.$router.push(`/~${this.getAccount.screen_name}/invite`)
          } else {
            this.$router.push('/account')
          }
        } else {
          this.$router.push('/n/welcome?n=sign-in');
        }
      },
      
      routeAccount() {
        this.showProfile = false;
        this.tap('Account');
        this.$router.push('/account')
      },

      triggerSignIn() {
        this.EventBus.$emit('modal:auth', 'sign-in');
      },

      triggerGoPro() {
        this.EventBus.$emit("didSelectSubscribe", {
          didSelect: 'true' 
        });
      },

      getApp() {
        this.EventBus.$emit('layer:new', {
          component: 'download-app',
          hasTabBar: false,
        });

        // if (this.deviceType == 'ios') {
        //   window.open('https://nourished.news/ios', '_blank').focus();
        // } else if (this.deviceType == 'android') {
        //   window.open('https://nourished.news/android', '_blank').focus();
        // } else {
        //   // Fire QR Modal
        //   this.EventBus.$emit('modal:qr');
        // }
      },

      possibleTop(e) {
        let sTo = e.target?.closest('[data-to]')?.dataset?.to || '/';
        let sPath = e.target?.pathname || sTo || '/';
        // console.log(`\x1b[32m[Nav:Click] `, sPath, this.debuouncedRoutePath);
        if (sPath == this.debuouncedRoutePath) {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
          // ------
          if (sPath == '/') {
            // console.log(`\x1b[32m[Nav:Click] RELOAD!`);
            // tell the user we're reloading!
            this.EventBus.$emit("device:haptic", 'success');

            // API.getHomeV6({ cluster: 'cat', force: true, });

            // reload the pro edition (if they're a pro?)
            // if (this.isPro) {
            //   API.getHomePro({ cluster: 'cat', force: true, });
            // }
          }
        } else if (sTo) {
          // console.log(`\x1b[32m[Nav:Click] Going to... `, sPath);
          this.$router.push(sTo);
        }
        // console.log(`\x1b[32m[Nav:Click] Nothing to do?`, e.target);
      },

      startOnboarding(sFallbackInvite = null) {
        this.$userEngine.startGuestOnboarding(sFallbackInvite);
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .drop-header {
    width: calc(100% + 2rem);
    margin: 0 -1rem;
    padding: 0 1rem; // same side padding as .nourish-header
    box-sizing: border-box;
    background: $neutral-600;
    border-bottom: 1px solid rgba($neutral-400, 0.25);

    .darkmode & {
      background: $neutral-100;
    }

    .section-nav {
      max-width: 1400px;
      margin: 0 auto;
      padding: 0 1rem;
      display: flex;
      gap: 1.5rem;
      list-style: none;

      li {
        display: flex;
      }

      a {
        display: block;
        padding: 1.125rem 0;
        font-size: 0.9rem;
        font-weight: bold;
        color: $neutral-400;
        text-decoration: none;
        border-bottom: 2px solid transparent;
        transition: color 0.18s ease, border-color 0.18s ease;

        &:hover {
          color: $neutral-100;
          text-decoration: none;

          .darkmode & {
            color: $neutral-600;
          }
        }

        &.active {
          color: $neutral-100;
          // border-bottom-color: $neutral-100;
          border-bottom-color: $yellow-tone-3;

          .darkmode & {
            color: $neutral-600;
            // border-bottom-color: $neutral-600;
            border-bottom-color: $yellow-tone-3;
          }
        }
      }
    }
  }

  .nourish-header {
    position: fixed;
    top: 0;
    width: 100%;
    padding: env(safe-area-inset-top) 1rem 0 1rem;
    height: calc(env(safe-area-inset-top) + $header-height);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background: $neutral-600;
    border-bottom: 1px solid rgba($neutral-400, 0.25);
    color: $neutral-100;
    z-index: 9999999;

    .darkmode & {
      background: $neutral-100;
      color: $neutral-600;
    }

    .inner-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      max-width: 1400px;
      margin: 0 auto;
    }

    .left {
      display: flex;
      align-items: center;
      gap: 1.5rem;
      padding-left: 1rem;

      .mobile & {
        padding-left: 0;
      }

      .heading-brand {
        text-indent: -9999px;
        background-image: url('~@assets/images/brand/nourish-dark.svg');
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        width: 1.8rem;
        height: 100%;
        display: block;
        cursor: pointer;
        font-size: 1.3rem;

        .darkmode & {
          background-image: url('~@assets/images/brand/nourish-light.svg');
        }
      }

      .links {
        display: flex;
        align-items: center;
        gap: 1.5rem;

        .mobile & {
          display: none;
        }

        .tab-item {
          display: flex;
          flex-direction: row;
          gap: 0.5rem;
          align-items: center;
          align-self: center;
          justify-self: center;
          font-size: 0.9rem;
          font-weight: bold;
          background: none;
          color: $neutral-400;
          cursor: pointer;

          &:hover {
            color: $neutral-100;
            
            .darkmode & {
              color: $neutral-600;
            }
          }

          svg {
            path {
              fill: $neutral-400;
            }
          }

          &.active {
            color: $neutral-100;

            svg path {
              fill: $neutral-100;
            }

            .darkmode & {
              color: $neutral-600;

              svg path {
                fill: $neutral-600;
              }
            }
          }
        }
      }
    }

    .right {
      display: flex;

      .right-content {
        display: flex;
        align-items: center;
        gap: 1rem;
        margin-right: 0.5rem;
        height: $header-height;

        .mobile & {
          margin-right: 0;
        }

        .profile-stack {
          position: relative;
          display: flex;
          align-items: center;
          height: $header-height;
          cursor: pointer;

          .user-account {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            text-align: right;
            font-weight: bold;
            gap: 0.1rem;
          } 

          .profile-expand {
            position: absolute;
            top: calc(env(safe-area-inset-top) + $header-height);
            right: 0;
            width: 22rem;
            display: flex;
            padding: 1.4rem 1.2rem 1.8rem 1.2rem;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
            border: 1px solid rgba($neutral-400, 0.25);
            background: $neutral-600;

            .darkmode & {
              background: $neutral-100;
            }

            .mobile & {
              position: fixed;
              // top: 3.5rem;
              top: calc(env(safe-area-inset-top) + $header-height - 1px);
              left: 0;
              right: 0;
              width: 100%;
              border-left: 0;
              border-right: 0;
            }

            .stack {
              display: flex;
              flex-direction: column;
              gap: 1rem;
              width: 100%;

              .stack-stat {
                display: flex;
                align-items: center;
                gap: 0.5rem;
              }

              .xp-progress {
                position: relative;
                width: 100%;
                height: 5px;
                border-radius: 500px;
                background: rgba($neutral-100, 0.1);

                .darkmode & {
                  background: rgba($neutral-600, 0.1);
                }

                .inner-progress {
                  position: absolute;
                  top: 0;
                  left: 0;
                  height: 5px;
                  border-radius: 500px;
                  background: $purple-tone-3;

                  .darkmode & {
                    background: $purple-tone-2;
                  }
                }

                .avg-marker {
                  position: absolute;
                  top: -25px;
                  left: 85%;
                  height: 15px;

                  span {
                    display: inline-block;
                    font-weight: bold;
                    font-size: 0.6rem;
                    margin-bottom: 3px;
                  }

                  .marker-mark {
                    margin: auto;
                    height: 100%;
                    width: 2px;
                    background: $purple-tone-3;

                    .darkmode & {
                      background: $purple-tone-2;
                    }
                  }
                }
              }

              .stack-group {
                display: flex;
                align-items: center;
                justify-content: space-between;
              }

              .xp,
              .streak {
                display: flex;
                flex-direction: column;
                gap: 1.5rem;
                flex: 1;
                padding: 1rem;
                border-radius: 10px;

                .icon {
                  padding-top: 4px;
                  svg {
                    height: 2rem;
                    width: 2rem;
                  }
                }

                .count {
                  font-size: 3rem;
                  font-weight: bold;
                }

                .label {
                  font-size: 0.9rem;
                  line-height: 120%;
                  font-weight: bold;
                  padding-top: 2px;
                }

                .average {
                  display: flex;
                  flex-direction: column;
                  gap: 0.1rem;
                  opacity: 0.75;
                  text-align: right;

                  .count {
                    font-size: 0.8rem;
                  }

                  .label {
                    font-size: 0.8rem;
                    font-weight: normal;
                  }
                }
              }

              .xp {
                background: rgba($purple-tone-3, 0.15);
                color: $purple-tone-3;

                .darkmode & {
                  color: $purple-tone-2;
                }

                .icon {
                  svg path {
                    fill: $purple-tone-3;

                    .darkmode & {
                      fill: $purple-tone-2;
                    }
                  }
                }
              }

              .streak {
                background: rgba($orange-tone-3, 0.15);
                color: $orange-tone-3;

                .icon {
                  svg path {
                    fill: $orange-tone-3;
                  }
                }

                &.streak-today {
                  background: rgba($green-tone-3, 0.15);
                  color: $green-tone-3;

                  .icon {
                    svg path {
                      fill: $green-tone-3;
                    }
                  }
                }
              }

              .stack-actions {
                display: flex;
                gap: 1rem;
                align-items: center;
                justify-content: center;
                margin-top: 1rem;

                .stack-btn {
                  height: unset;
                  border-radius: 0;
                  font-size: 0.8rem;
                  background: none;
                  border-bottom: 1px solid $neutral-400;
                  padding: 0;
                  padding-bottom: 3px;
                  color: $neutral-400;
                  font-weight: normal;

                  &:hover {
                    color: $neutral-100;
                    border-color: $neutral-100;

                    .darkmode & {
                      color: $neutral-600;
                      border-color: $neutral-600;
                    }
                  }
                }
              }
            }
          }
        }

        .button-stack {
          display: flex;
          gap: 0.5rem;

          .button {
            height: 2.4rem;
            padding: 0 0.75rem;
            font-size: 0.8rem;
          }

          .sign-in {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0 1rem;

            svg path {
              fill: black;
            }
          }
        }

        button {
          height: 2.4rem;
          padding: 0 0.75rem;
          font-size: 0.8rem;

          &.pro {
            display: flex;
            align-items: center;
            gap: 0.25rem;
            background: $green-tone-3;
            color: $green-tone-6;

            svg {
              width: 1rem;
              height: 1rem;
              fill: $green-tone-6;
              padding-bottom: 2px;
            }
          }

          &.app {
            background: rgba($yellow-tone-6, 0.1);
            color: $yellow-tone-4;

            .darkmode & {
              background: rgba($yellow-tone-6, 0.5);            
              color: $yellow-tone-3;
            }
          }
        }
      }

      .user-track {
        width: 70px;
        height: 70px;
        margin-bottom: -1.5rem;
        
        border-radius: 500px;
        background: $neutral-600;

        .darkmode & {
          background: $neutral-100;
        }

        .mobile & {
          display: none;
        }
      }
    }
  }

  .expand-enter-active,
  .expand-leave-active {
    transition: all 0.3s ease;
    overflow: hidden;
  }

  .expand-enter,
  .expand-leave-to {
    max-height: 0;
    opacity: 0;
  }

  .expand-enter-to,
  .expand-leave {
    max-height: 500px;
    opacity: 1;
  }
</style>